<script>
  import axios from 'axios';
  import AS from '@/services/AuthenticationService';

  export default {
    all({ page, limit, q }) {
      return axios.get(`admin/employees?page=${ page }&limit=${ limit }&q=${ q }`, AS.getDefaultHeaders());
    },
    createOrUpdate(payload) {
      if (payload.id === '') {
        return axios.post('admin/employees', payload, AS.getDefaultHeaders());
      }
      return axios.patch(`admin/employees/${ payload.id }`, payload, AS.getDefaultHeaders());
    },
    sendResetPasswordInstruction(id){
      return axios.get(`admin/employees/${id}/sent_reset_password_instruction`, AS.getDefaultHeaders());
    },
    resetPassword(payload){
      return axios.post(`admin/employees/reset_password`, payload, AS.getDefaultHeaders());
    }
  };
</script>
